export interface Layout {
    width: number;
    height: number;
    isNarrow: boolean;
    marginLeft: number;
    marginRight: number;
    innerW: number;
    plotTop: number;
    plotBottom: number;
    stripTop: number;
    stripH: number;
    axisY: number;
    split: number;
    histW: number;
    fwdW: number;
}

const MARGIN_TOP = 18;
const MARGIN_BOTTOM = 50;
const MARGIN_RIGHT = 12;
const STRIP_H = 14;
const STRIP_GAP = 10;

export const NARROW_BREAKPOINT = 700;
export const MIN_CHART_HEIGHT = 320;

export function computeLayout(width: number, height: number): Layout {
    const isNarrow = width > 0 && width < NARROW_BREAKPOINT;
    const h = Math.max(MIN_CHART_HEIGHT, height);

    const marginLeft = isNarrow ? 42 : 52;
    const innerW = Math.max(240, width - marginLeft - MARGIN_RIGHT);
    const plotBottom = h - MARGIN_BOTTOM - STRIP_H - STRIP_GAP;
    const stripTop = plotBottom + STRIP_GAP;

    const splitRatio = isNarrow ? 0.56 : 0.67;
    const histW = innerW * splitRatio;

    return {
        width,
        height: h,
        isNarrow,
        marginLeft,
        marginRight: MARGIN_RIGHT,
        innerW,
        plotTop: MARGIN_TOP,
        plotBottom,
        stripTop,
        stripH: STRIP_H,
        axisY: stripTop + STRIP_H,
        split: marginLeft + histW,
        histW,
        fwdW: innerW - histW,
    };
}
